var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import styled from 'styled-components';
import Label from '../../../../components/Label';
import { langs } from '@uiw/codemirror-extensions-langs';
export var StyledTemplateEditor = styled(CodeMirror)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  margin-bottom: 0.5rem;\n"], ["\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  margin-bottom: 0.5rem;\n"])));
var TemplateEditor = function (_a) {
    var initialContent = _a.initialContent, onChange = _a.onChange, label = _a.label;
    // const { initialContent, onChange, format } = props;
    var _b = useState(initialContent), content = _b[0], setContent = _b[1];
    useEffect(function () {
        setContent(initialContent);
    }, [initialContent]);
    return (_jsxs("div", { children: [_jsx(Label, { label: label }), _jsx(StyledTemplateEditor, { value: (content === null || content === void 0 ? void 0 : content.body) || '', basicSetup: {
                    lineNumbers: true
                }, onChange: function (value) {
                    setContent({ body: value });
                    onChange(value);
                }, extensions: [langs.html()] })] }));
};
export default TemplateEditor;
var templateObject_1;
